export default {
	"searchDemo": {
		"searchBy": "搜索引擎模型",
		"searchKey": "搜索词",
		"searchKeyList": "热词案例",
		"account": "账户",
		"device": "跟踪设备",
		"users": "人员",
		"capacity": "运力",
		"hotKeyList": "热词回填案例",
		"mobile": "联系电话",
		"hotKeyMoreList": "热词多维度案例"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/search/search.js